import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { api } from "../lib/api";
import { Section, Toggle } from "./Common";
import { pct, dot } from "../lib/fmt";

export default function Ranking({ data }) {
  const [days, setDays] = useState(30);
  const [res, setRes] = useState(data.ranking);
  const stamp = data.reports.length + (data.myToday?.code || "");
  useEffect(() => {
    if (days === 30) {
      setRes(data.ranking);
      return;
    }
    api.get("/ranking", { params: { days } }).then((r) => setRes(r.data)).catch(() => {});
  }, [days, stamp, data.ranking]);
  const meId = data.me?.id;
  return (
    <Section id="ranking" eyebrow="Peringkat Kedisiplinan" title="Paling rajin lapor"
      right={<Toggle testid="ranking-days-toggle" value={days} onChange={setDays} options={[[7, "7 hari"], [30, "30 hari"], [90, "90 hari"]]} />}>
      <div className="space-y-2" data-testid="ranking-list">
        {res.rows.length === 0 && <div className="card p-5 text-sm text-[#7a6667]">Belum ada data peringkat.</div>}
        {res.rows.map((r) => {
          const mine = r.memberId === meId;
          const w = r.due ? Math.round((r.filled * 100) / r.due) : 0;
          return (
            <div key={r.memberId} data-testid={`ranking-row-${r.memberId}`}
              className={`card flex flex-wrap items-center gap-x-4 gap-y-2 p-3.5 ${mine ? "border-brand bg-brand-soft" : ""}`}>
              <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-extrabold ${r.rank <= 3 ? "bg-brand text-white" : "bg-brand-tint text-brand-deep"}`}>{r.rank}</div>
              <div className="min-w-[120px] flex-1">
                <div className="font-extrabold">{r.name} {mine && <span className="text-brand">(Anda)</span>}</div>
                <div className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-brand-line/60">
                  <div className="h-full rounded-full bg-brand transition-[width] duration-500" style={{ width: `${w}%` }} />
                </div>
                <div className="mt-1 text-xs text-[#7a6667]">{r.filled} dari {r.due} hari kerja</div>
              </div>
              <div className="text-2xl font-extrabold tabular-nums text-brand">{pct(r.pct)}</div>
              <div className="flex flex-wrap items-center gap-2 text-xs">
                <span className="rounded-full border border-brand-line px-2.5 py-1">Tepat waktu <b>{pct(r.onTimePct)}</b></span>
                <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 px-2.5 py-1 font-bold text-amber-700"><Flame size={12} /> {r.streak}</span>
                <span className="rounded-full border border-brand-line px-2.5 py-1">Rata² {r.avgTime ? dot(r.avgTime) : "–"}</span>
                <span className="rounded-full border border-brand-line px-2.5 py-1">Terlewat <b className={r.missed ? "text-brand" : ""}>{r.missed}</b></span>
              </div>
            </div>
          );
        })}
      </div>
      {res.limited && (
        <p data-testid="ranking-limited-note" className="mt-3 text-xs text-[#7a6667]">Anda melihat 3 teratas{meId ? " dan posisi Anda sendiri" : ""}. Peringkat lengkap hanya untuk Leader & Manager.</p>
      )}
    </Section>
  );
}
